<template>
  <div class="loginContBox" v-loading.fullscreen.lock="fullscreenLoading">
    <div class="logoBox">
      <div class="logo">
        <img src="@/assets/image/yaoyao.png" height="35" class="mr-3" />
        <img src="@/assets/image/logo_long.png" height="100%" />
      </div>
      <div class="name">
        {{webTitleName}}
      </div>
    </div>
    <div class="loginBody">
      <div style="flex:1"></div>
      <div class="loginControl">
        <div class="title">
          <svg class="icon" aria-hidden="true">
            <use xlink:href="#fax-circle-left"></use>
          </svg>
          <span>账号登录</span>
          <svg class="icon" aria-hidden="true">
            <use xlink:href="#fax-circle-right"></use>
          </svg>
        </div>
        <div class="inputItem">
          <el-input placeholder="登录账号" v-model="txtLoginName" class="txtInput">
            <i slot="prefix" class="el-input__icon el-icon-user"></i>
          </el-input>
        </div>
        <div class="inputItem">
          <el-input show-password placeholder="登录密码" v-model="txtLoginPwd" class="txtInput"
            @keyup.enter.native="onWebLogin()">
            <i slot="prefix" class="el-input__icon el-icon-lock"></i>
          </el-input>
        </div>
        <div class="spErrCont">{{tipErr}}</div>
        <div class="loginBtn">
          <el-button type="primary" size="medium" class="btnLogin" @click="onWebLogin()">立即登录</el-button>
        </div>
      </div>
    </div>
    <div class="footer">
      {{webCopyright}}
      <a href="https://beian.miit.gov.cn/" target="_blank" v-if="!regNull(webICP)">
        {{webICP}}
      </a>
    </div>
  </div>

</template>
<script>
  import versionTood from '@/plugins/versionUpdate.js';
  export default {
    data() {
      return {
        // 登录帐号
        txtLoginName: '',
        // 登录密码
        txtLoginPwd: '',
        // 验证提示语
        tipErr: '',
        fullscreenLoading: false,
        strIcp: null,
        webTitleName: webTitleName(),
        webCopyright: webCopyright(),
        webICP: webICP(),
        isPower: {
          studentmgt: false,
          academicmgt: false,
          hr_management: false,
          enrollmentmgt: false,
          system: false,

          teacher_workbench: false,
          admin_affairs_workbench: false,
          management_workbench: false,
          admin_system_workbench: false,
          batch_index: false
        },
        optionUrl: null,
      };
    },
    created() {
      let that = this;

      // versionTood.isNewVersion();

      let path = decodeURIComponent(that.$route.query.url);
      let paths = path.toLowerCase().split("/login?url=");
      let tpURL = paths[paths.length - 1];
      if (!regNull(tpURL)) {
        // that.optionUrl = tpURL.indexOf("login?url=") < 0?tpURL:null;
      }
    },
    mounted() {
      let that = this;
      window.onresize = () => {
        return (() => {
          that.$nextTick(() => {
            $('.loginBody').css('height', $(document).height());
          });
        });
      };
    },
    methods: {
      onWebLogin() {
        // 验证登录用户名和密码是否为空
        let that = this;
        if (!that.$Verify_Null(that.txtLoginName) || !that.$Verify_Null(that.txtLoginPwd)) {
          that.tipErr = '用户名或密码不能为空';
          return false;
        }
        // MD5 加密
        var password = this.$md5(that.txtLoginPwd);
        //赋值
        let data = {
          "username": that.txtLoginName,
          "password": password,
        };
        that.fullscreenLoading = true;
        that.tipErr = "";

        // 登录 获取token
        ajaxLogin(that, "/api/auth/token", data, function(res) {
          if (res.data.data.success != false) {
            that.fullscreenLoading = false;

            that.$RemoveKey();
            that.$SaveKey(new Date(), 'tokenTime');
            that.$SaveKey(res.data.data.token); // token

            if (res.data.data.token.userType == 1) {
              // 教师登录
              // 获取活动类型树形列表
              ajaxGet(that, "/api/admin/ActivityType/treelist", null, function(resType) {
                if (resType.length > 0) {
                  that.$SaveKey(resType, "activityTypes");
                }



                // 获取菜单权限
                ajaxGet(that, "/api/admin/sysAction/byuser", null, function(resAction) {
                  if (resAction.success == true) {
                    // 判断是否有权限
                    if (resAction.data.actions == null || resAction.data.actions.length <= 0) {
                      that.$RemoveKey();
                      warning(that, "该用户没有任何权限，无法登录，请联系管理员");
                      return false;
                    }
                    //获取班主任是当前用户的班级
                    ajaxGet(that, "/api/admin/class/userclass", null, function(resManageClass) {
                      //当前用户所有班级范围
                      ajaxGet(that, "/api/admin/sysuser/userfilter", null, function(resAllClass) {

                        // 用于缓存教师信息
                        let tempTeacher = {
                          isTeacher: false, // 是否是班主任
                          manageClass: [], // 如果是班主任这里记录所管辖的班级
                          allClass: [], // 学生范围
                        };
                        // 判断是否有管辖班级，有则视为班主任
                        if (!regNullArray(resManageClass)) {
                          tempTeacher.isTeacher = true;
                          // 记录班级
                          resManageClass.forEach(function(item) {
                            tempTeacher.manageClass.push({
                              classId: item.classId,
                              name: item.name,
                            });
                          });
                        }

                        // 判断是否有学生范围
                        if (!regNullArray(resAllClass)) {
                          resAllClass.forEach(function(item) {
                            tempTeacher.allClass.push({
                              classId: item.classId,
                              name: item.name,
                            });
                          });
                        }
                        // 记录教师的数据
                        that.$SaveKey(tempTeacher, that.$cacheTeacher);
                        ajaxGet(that, '/api/admin/sysuser/currentuser', null, function(resUser) {
                          that.$SaveKey(resUser.userId, "currentUserID");
                        })
                        ajaxGet(that, '/api/admin/teacher/user', null, function(r1) {
                          if (!regNull(r1)) {
                            that.$SaveKey(r1.teacherId, 'teacherId');
                          }
                        })
                        // 获取教师考评
                        ajaxGet(that, '/api/admin/teacherevaluation/selfevaluation', null, function(
                          resEvaluation) {
                          if (!regNull(resEvaluation)) {
                            if (!regNull(resEvaluation.semesterEvaluation) || !regNull(
                                resEvaluation.yearEvaluation)) {
                              that.$SaveKey(resEvaluation, "evaluationTypes");
                            }
                          }
                        });



                        // 记录教师的用户名和姓名
                        let tempName = {
                          sysName: resAction.data.userName,
                          name: resAction.data.name
                        }
                        that.$SaveKey(tempName, that.$cacheTeacherName);
                        // 记录权限信息
                        that.$SaveKey(resAction.data.actions, "actions");
                        // 记录菜单信息
                        that.$SaveKey(resAction.data.menus, "menus");
                        // 记录教师的姓名（临时）
                        that.$SaveKey(resAction.data.name, "Name");
                        // 用于判断登录角色
                        that.$SaveKey(true, "isManager");

                        isPower(that, "studentmgt", "studentmgt");
                        isPower(that, "academicmgt", "academicmgt");
                        isPower(that, "hr_management", "hr_management");
                        isPower(that, "enrollmentmgt", "enrollmentmgt");
                        isPower(that, "system", "system");

                        isPower(that, "teacher_workbench", "teacher_workbench");
                        isPower(that, "admin_affairs_workbench", "admin_affairs_workbench");
                        isPower(that, "management_workbench", "management_workbench");
                        isPower(that, "batch_index", "batch_index");
                        isPower(that, "admin_system_workbench", "admin_system_workbench");

                        // 判断是否有其他页面跳转过来的
                        // var path = decodeURIComponent(that.$route.query.url);
                        // if (path != null && typeof(path) != "undefined" && path != "undefined" &&
                        //   path != "") {
                        //   var paths = path.toLowerCase().split("/login?url=");
                        //   var url = paths[paths.length - 1];
                        //   if (url != null && typeof(url) != "undefined" && url != "undefined" &&
                        //     url != "") {
                        //     that.$router.replace(url);
                        //   } else {
                        //     if (that.isPower.studentmgt) {
                        //       if (that.isPower.teacher_workbench) {
                        //         that.$router.replace("/Admin/Workbench/Student");
                        //       } else {
                        //         that.$router.replace('/admin/home/Default');
                        //       }
                        //     } else if (that.isPower.academicmgt) {
                        //       if (that.isPower.admin_affairs_workbench) {
                        //         that.$router.replace("/Admin/Workbench/Affairs");
                        //       } else {
                        //         that.$router.replace('/admin/home/Default');
                        //       }
                        //     } else if (that.isPower.hr_management) {
                        //       if (that.isPower.management_workbench) {
                        //         that.$router.replace("/Admin/Workbench/Personnel");
                        //       } else {
                        //         that.$router.replace('/admin/home/Default');
                        //       }
                        //     } else if (that.isPower.enrollmentmgt) {
                        //       if (that.isPower.batch_index) {
                        //         that.$router.replace("/Admin/RecruitStudents/Batch/Index");
                        //       } else {
                        //         that.$router.replace('/admin/home/Default');
                        //       }
                        //     } else if (that.isPower.system) {
                        //       if (that.isPower.admin_system_workbench) {
                        //         that.$router.replace("/Admin/Workbench/System");
                        //       } else {
                        //         that.$router.replace('/admin/home/Default');
                        //       }
                        //     } else {
                        //       that.$router.replace('/admin/home/Default');
                        //     }
                        //   }
                        // } else {
                        //  }
                         
                         
                         if (that.isPower.studentmgt) {
                             if (that.isPower.teacher_workbench) {
                               that.$router.replace("/Admin/Workbench/Student");
                             } else {
                               that.$router.replace('/admin/home/Default');
                             }
                           } else if (that.isPower.academicmgt) {
                             if (that.isPower.admin_affairs_workbench) {
                               that.$router.replace("/Admin/Workbench/Affairs");
                             } else {
                               that.$router.replace('/admin/home/Default');
                             }
                           } else if (that.isPower.hr_management) {
                             if (that.isPower.management_workbench) {
                               that.$router.replace("/Admin/Workbench/Personnel");
                             } else {
                               that.$router.replace('/admin/home/Default');
                             }
                           } else if (that.isPower.enrollmentmgt) {
                             if (that.isPower.batch_index) {
                               that.$router.replace("/Admin/RecruitStudents/Batch/Index");
                             } else {
                               that.$router.replace('/admin/home/Default');
                             }
                           } else if (that.isPower.system) {
                             if (that.isPower.admin_system_workbench) {
                               that.$router.replace("/Admin/Workbench/System");
                             } else {
                               that.$router.replace('/admin/home/Default');
                             }
                           } else {
                             that.$router.replace('/admin/home/Default');
                           }
                         

                      });
                    });
                  } else {
                    that.$RemoveKey();
                  }
                });
              });
            } else {
              // 学生
              // 获取学生信息
              ajaxGet(that, '/api/student/student', null, function(resStudent) {
                if (!regNull(resStudent)) {
                  // 记录学生的学号和姓名
                  that.$SaveKey(resStudent, that.$cacheStudent);
                  that.$SaveKey(resStudent.studentNo, 'StudentNo');
                  var path = decodeURIComponent(that.$route.query.url);
                  if (path != null && typeof(path) != "undefined" && path != "undefined" && path != "") {
                    var paths = path.toLowerCase().split("/login?url=");
                    var url = paths[paths.length - 1];
                    if (url != null && typeof(url) != "undefined" && url != "undefined" && url != "") {
                      that.$router.replace(url);
                    } else {
                      that.$router.replace('/student/SelfReport/index');
                    }
                  } else {
                    that.$router.replace('/student/SelfReport/index');
                  }
                } else {
                  that.$RemoveKey();
                }
              });
            }

          } else {
            that.fullscreenLoading = false;
            that.tipErr = res.data.data.message;
          }
        });
      },
    },
  };
</script>
<style scoped="scoped" lang="less">
  .loginBody {
    width: 100%;
    height: calc(100vh);
    display: -webkit-flex;
    display: flex;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    -webkit-justify-content: center;
    justify-content: center;
    -webkit-box-align: center;
    -ms-flex-align: center;
    -webkit-align-items: center;
    align-items: center;
  }




  .loginControl {
    margin-right: 10%;
    background-color: #FFFFFF;
    width: 25.625rem;
    height: 25rem;
    border-radius: 0.3125rem;

    .spErrCont {
      height: 1.25rem;
      color: #fa3534;
      font-size: 0.75rem;
      margin-left: 4.0625rem;
      margin-right: 4.0625rem;
    }
  }

  .loginControl .title {
    margin-top: 1.875rem;
    color: #406AD3;
    text-align: center;
    padding-top: 0.9375rem;
    margin-bottom: 3rem;

  }

  .loginControl .title span {
    padding-left: 0.625rem;
    padding-right: 0.625rem;
    font-size: 1.25rem;
    color: #000000;
  }

  .loginControl .inputItem {
    text-align: center;
    margin-left: 4.0625rem;
    margin-right: 4.0625rem;
    margin-bottom: 0.9375rem;

  }


  .loginControl .loginBtn {
    text-align: center;
    margin-left: 4.0625rem;
    margin-right: 4.0625rem;
  }

  .loginControl .btnLogin {
    font-size: 0.875rem;
    width: 100%;
    background-color: #406AD3;
    margin-bottom: 0.3125rem;
    margin-top: 0.9375rem;
  }

  .loginControl .loginLink {
    margin-left: 4.0625rem;
    margin-right: 4.0625rem;
  }

  .loginControl .loginLink .alogin {
    font-size: 0.75rem;
    color: #767676;
  }


  .loginContBox {
    display: flex;
    height: 100%;
    color: #FFFFFF;
    background: url(../assets/image/Login/img_login.jpg) no-repeat;
    background-position: center center;
    background-size: auto 120%;
  }

  .logoBox {
    position: fixed;
    top: 1.875rem;
    left: 1.875rem;
    display: flex;
  }

  .logoBox .logo {
    height: 2.5rem;
    /*40*/
    border-right: 0.0625rem solid #FFFFFF;
    padding-right: 0.9375rem;
    padding-top: 0.125rem;
    padding-bottom: 0.125rem;
  }

  .logoBox .name {
    padding-left: 0.9375rem;
    font-size: 1.75rem;
    margin-top: -0.0625rem;
  }

  .footer {
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    height: 2.5rem;
    background-color: #395FBF;
    text-align: center;
    font-size: 0.75rem;
    line-height: 2.5rem;
  }

  .footer a {
    color: #FFFFFF;
    font-size: 0.75rem;
    margin-left: 0.3125rem;
  }
</style>
<style scoped="scoped">
  /*当屏幕尺寸小于1600px时，应用下面的CSS样式*/
  @media screen and (max-width: 1650px) {
    .loginImg {
      height: 31.25rem;
      margin-right: 5%;
    }

  }
</style>
